/**
 * 这段代码不知道从哪弄的，把它格式化了，便于排查问题调试
 */
(function() {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          const c = typeof require === 'function' && require
          if (!f && c) return c(i, !0)
          if (u) return u(i, !0)
          const a = new Error('Cannot find module \'' + i + '\'')
          throw a.code = 'MODULE_NOT_FOUND',
          a
        }
        const p = n[i] = {
          exports: {}
        }
        e[i][0].call(p.exports,
          function(r) {
            const n = e[i][1][r]
            return o(n || r)
          },
          p, p.exports, r, e, n, t)
      }
      return n[i].exports
    }
    for (var u = typeof require === 'function' && require,
      i = 0; i < t.length; i++) o(t[i])
    return o
  }
  return r
})()({
  1: [function(require, module, exports) {
    !(function(t) {
      t.SealTool = t.util.createClass(t.BaseBrush, {
        color: '#ff0000',
        width: 50,
        _baseWidth: 300,
        _lastPoint: null,
        _point: null,
        brush: null,
        initialize(s, i) {
          const n = this
          i = i || {},
          this.canvas = s,
          this.width = i.width || s.freeDrawingBrush.width,
          this.color = i.color || s.freeDrawingBrush.color,
          this.brushDataUrl = i.brushDataUrl,
          this.canvas.contextTop.lineJoin = 'round',
          this.canvas.contextTop.lineCap = 'round',
          this._scale = i.scale || 0.3
          this._reset()
          t.Image.fromURL(this.brushDataUrl,
            function(t) {
              n.brush = t,
              n.brush.filters = [],
              n.changeColor(n.color || this.color)
            },
            {
              crossOrigin: 'anonymous'
            })
        },
        changeColor(s) {
          this.color = s,
          this.brush.filters[0] = new t.Image.filters.BlendColor({
            color: s,
            mode: 'tint'
          }),
          this.brush.applyFilters(),
          this.canvas.renderAll()
        },
        onMouseDown(s) {
          // 添加 setTimeout 先执行 mouse:down
          console.log('onMouseDown')
          // 画图模式没有打开
          if (!this.canvas.isDrawingMode) {
            return
          }
          this._point = new t.Point(s.x, s.y)
          this._lastPoint = this._point
          this.size = this.width + this._baseWidth
          this.changeColor(this.color)
          this._render()
        },
        onMouseMove(s) {
          this._lastPoint = this._point,
          this._point = new t.Point(s.x, s.y)
        },
        onMouseUp(t) {},
        _render() {
          function s() {
            let s,
              n
            new t.Point(i._point.x || 0, i._point.y || 0),
            s = i._lastPoint.x - i.size * i._scale / 2,
            n = i._lastPoint.y - i.size * i._scale / 2
            const o = new t.Image(i.brush._element, {
              scaleX: i._scale,
              scaleY: i._scale,
              left: s,
              top: n
            })
            i.canvas.add(o),
            i.canvas.contextTop.save(),
            i.canvas.contextTop.restore(),
            i._reset()
          }
          var i = this || this.canvas.contextTop
          setTimeout(s, 20)
        },
        _reset() {
          this._setBrushStyles(this.canvas.contextTop),
          this._point = null,
          this._lastPoint = null
        }
      })
    }(fabric))
  },
  {}]
},
{},
[1])